/** CRM 單價含稅方式顯示（表單／API value 仍為 TAX_EXCLUSIVE／TAX_INCLUSIVE）。 */

export const PRICE_TAX_MODE_LABELS = {
  TAX_EXCLUSIVE: '未稅單價',
  TAX_INCLUSIVE: '含稅單價',
};

export function formatPriceTaxMode(mode) {
  if (mode == null || mode === '') {
    return '—';
  }
  return PRICE_TAX_MODE_LABELS[mode] ?? mode;
}
